exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tevkifat-secenegi[data-v-3394fc88] .v-label,.vade-secenegi[data-v-3394fc88] .v-label{white-space:normal;line-height:1.3}.bilet-baglantisi[data-v-3394fc88]{text-decoration:underline;cursor:pointer}.tevkifat-satiri[data-v-3394fc88]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.tevkifat-info[data-v-3394fc88]{cursor:pointer;margin-left:4px}.tevkifat-aciklama[data-v-3394fc88]{margin:4px 0 8px 32px;line-height:1.3}", ""]);

// exports
